import { render, staticRenderFns } from "./ProductRequest.vue?vue&type=template&id=4c9a1db4"
import script from "./ProductRequest.vue?vue&type=script&lang=js"
export * from "./ProductRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9a1db4')) {
      api.createRecord('4c9a1db4', component.options)
    } else {
      api.reload('4c9a1db4', component.options)
    }
    module.hot.accept("./ProductRequest.vue?vue&type=template&id=4c9a1db4", function () {
      api.rerender('4c9a1db4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ProductRequest.vue"
export default component.exports